export default {
  certificacao: {
    descricao: 'Descripción',
    dataCadastro: 'Fecha de Registro',
    falhaoAoBuscarDados: 'No se pudieron recuperar los datos',
    certificacoes: 'Certificaciones ecosocial',
    desejaExcluirCertificacao: '¿Quieres eliminar esta certificación?',
    nao: 'No',
    excluir: 'Eliminar',
    certificacaoExcluida: 'Certificación eliminada correctamente',
    falhaoAoExcluir: 'No se pudo borrar la certificación',
    cadastroDeCertificacao: 'Registro de certificación ecosocial',
    campoObrigatorio: 'Campo obligatorio',
    identificacao: 'Identificación',
    salvar: 'Ahorrar',
    cancelar: 'Cancelar',
    certificacaoSalvoComSucesso: 'Certificación guardada con éxito',
    falhaAoSalvar: 'No se pudo guardar la certificación',
    salvando: 'Saving',
    atualizando: 'Actualizando',
    produtorRelacionado: 'No fue posible excluir esta certificación porque hay un productor usándola'
  }
};
